import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";

export const NavbarSticky: FC = () => {
  let activePath = useLocation().pathname;
  let [scrollY, setScrollY] = useState(0);

  function handleScroll() {
    setScrollY(window.pageYOffset);
  }

  useEffect(() => {
    function watchScroll() {
      window.addEventListener("scroll", handleScroll);
    }
    watchScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  return (
    <nav
      className={`NavbarSticky ${scrollY >= 100 ? "NavbarSticky-white" : ""}`}
    >
      <ul className="Navbar_links">
        <li className={activePath === "/" ? "active" : ""}>
          <Link to="/">Home</Link>
        </li>
        <li className={activePath === "/about" ? "active" : ""}>
          <Link to="/about">About Us</Link>
        </li>
        <li className={activePath === "/solutions" ? "active" : ""}>
          <Link to="/solutions">Solutions</Link>
        </li>
        <li className={activePath === "/careers" ? "active" : ""}>
          <Link to="/careers">Careers</Link>
        </li>
        <li className={activePath === "/contract-vehicles" ? "active" : ""}>
          <Link to="contract-vehicles">Contract Engagement</Link>
        </li>
        <li className={activePath === "/news-and-awards" ? "active" : ""}>
          <Link to="/news">News and Awards</Link>
        </li>
        <li className={activePath === "/contacts" ? "active" : ""}>
          <Link to="/contacts">Contact</Link>
        </li>
      </ul>
    </nav>
  );
};
